/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
import InfoIcon from '@mui/icons-material/Info';
// @mui
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Autocomplete,
  Box,
  FormGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Grid,
  Card,
  CardContent,
  Typography,
  CardMedia,
} from '@mui/material';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// components
// import { ImageSelector } from './NewsModal';
import Iconify from '../../../components/iconify';
import API, { API_URL } from '../../../api';

export default function OrderDetail({ news, resetPage, categories, selectedOrder }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log(selectedOrder);
  const {
    acceptedFiles: acceptedPDFFiles,
    getRootProps: getPDFRootProps,
    getInputProps: getPDFInputProps,
  } = useDropzone({
    accept: {},
    maxFiles: 1,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MNT' }).format(amount);
  };

  return (
    <>
      <Button fullWidth sx={{ justifyContent: 'start' }} startIcon={<InfoIcon />} onClick={handleClickOpen}>
        Дэлгэрэнгүй
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
        <DialogTitle>Захиалгын дэлгэрэнгүй</DialogTitle>
        <DialogContent>
          {selectedOrder && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Card elevation={3} style={{ borderRadius: '8px', marginBottom: '16px', width: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Захиалгын дугаар: {selectedOrder.orderNumber}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Нэхэмжлэлийн дугаар: {selectedOrder.invoiceCode}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Дүн: {formatCurrency(selectedOrder.amount)}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Төлөв: {selectedOrder.status}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Огноо: {new Date(selectedOrder.createdAt).toLocaleDateString('en-CA')}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Хаяг: {selectedOrder.deliveryAddress}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Бараа:
                    </Typography>
                    <Grid container spacing={1}>
                      {selectedOrder.productDetails.map((detail, index) => (
                        <Grid item xs={12} key={index}>
                          <Card style={{ display: 'flex', marginBottom: '8px', borderRadius: '8px', width: '100%' }}>
                            <CardMedia
                              component="img"
                              style={{ width: 100, borderRadius: '8px 0 0 8px' }}
                              image={`https://back.store.ufe.mn/${detail.productDetailId.productId.productImages[0].imagePath}`}
                              alt={detail.productDetailId.productId.name}
                            />
                            <CardContent style={{ flex: 1 }}>
                              <Typography variant="body1" fontWeight="bold">
                                {detail.productDetailId.productId.name}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Хэмжээ: {detail.size.map((size) => `${size.name} (${size.quantity})`).join(', ')}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Өнгө: {detail.productDetailId.color.name}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Цуцлах</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
